import { fansupportPrivate } from "../index";

export const getNotification = async ({ page, perPage}) => {
    return fansupportPrivate.get('/notification', {params: {
        page,
        perPage,
    }})
}